import React from 'react';

import { BaseIcon } from '@/shared/assets/icons/base-icon/base-icon';
import { TBaseIcon } from '@/shared/assets/icons/base-icon/base-icon.types';

export const DotCircleIcon: React.FC<TBaseIcon> = (props) => {
  return (
    <BaseIcon
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M21.5984 11.9984C21.5984 17.3004 17.3004 21.5984 11.9984 21.5984C6.6965 21.5984 2.39844 17.3004 2.39844 11.9984C2.39844 6.6965 6.6965 2.39844 11.9984 2.39844C17.3004 2.39844 21.5984 6.6965 21.5984 11.9984Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M12.0272 16C9.85034 16 8 14.1918 8 12.0274C8 9.86301 9.85034 8 12.0272 8C14.2041 8 16 9.86301 16 12.0274C16 14.1918 14.1769 16 12.0272 16Z"
        fill="currentColor"
      />
    </BaseIcon>
  );
};

DotCircleIcon.displayName = 'DotCircleIcon';
